
import {
  Vue, Component, Prop, Watch, Ref,
} from 'vue-property-decorator'
import FormInput from '@/components/FormInput/FormInput.vue'
import Widget from '@/components/Widget/Widget.vue'
import { clone as _clone } from 'lodash'
// @ts-ignore
import LiquorTree from 'liquor-tree'
import 'vue-slider-component/theme/antd.css'
import CheckboxInput from '@/components/CheckboxInput/index.vue'
import DataForm from '@/components/DataForm/DataForm.vue'
import WebMessage from '@/models/WebMessage'
import TenantSharedModel from '@/models/TenantSharedModel'
import MediaPackage from '@/models/MediaPackage'
import Tenant from '@/models/Tenant'
import formData from './share_form'

Vue.use(LiquorTree)

@Component({
  components: {
    DataForm,
    FormInput,
    CheckboxInput,
    Widget,
  },
})
export default class ShareMediaPackageForm extends Vue {
  @Ref() readonly treeview: any

  @Prop({ default: '' })
  private id!: string

  @Prop()
  public modelId!: string

  @Prop({
    default: 'full',
  })
  private view_mode!: string

  public adunit_filter: string = ''

  public adunits = []

  public adunits_distribution: number[] = []

  public busy = false

  public loading = true

  public model: TenantSharedModel = new TenantSharedModel()

  public target: MediaPackage = new MediaPackage()

  public show_line_items_using_this: boolean = false

  public depending_line_items: any = []

  public confirm_update: any = false

  public response_msg: any = ''

  public can_save: boolean = true

  public get form() {
    return formData
  }

  public cancel() {
    if (this.view_mode == 'sidebar') {
      this.$emit('update:show_sidebar', false)
    } else {
      this.$router.push({ name: 'MediaProperties' })
    }
  }

  public onSubmit(model: TenantSharedModel) {
    this.busy = true

    this.target
      .shareModel(model)
      .then(response => {
        this.busy = false
        if (response.status == 200) {
          this.$router.push(`/app/sales/media_package/${this.target.id}/shares`)
        }
      })
      .catch(() => {
        WebMessage.error('There was an error sharing the Media Package. Please try again.')
        this.busy = false
      })
  }

  public init() {
    this.loading = true
    const { query } = this.$route

    MediaPackage.find(this.modelId).then(media_package => {
      if (media_package instanceof MediaPackage) {
        this.target = media_package

        if (this.id) {
          TenantSharedModel.find(this.id).then(model => {
            if (model instanceof TenantSharedModel) {
              this.model = model

              this.setModelData()

              this.loading = false
            }
          })
        } else {
          this.setModelData()
          this.loading = false
        }
      }
    })
  }

  public setModelData() {
    this.model.model_id = this.target.id ?? ''
    this.model.model_name = this.target.name
    this.model.model_type = 'App\\Models\\MediaPackage'

    if (!this.model.settings || Object.keys(this.model.settings).length === 0) {
      this.model.settings = {
        name: this.target.name,
        rate: this.target.rate,
      }
    }
  }

  public created() {
    this.init()
  }
}
